import { useRef } from 'react'

const HOLD_MS = 2000

const hardRefresh = async () => {
  try {
    if ( 'caches' in window ) {
      const keys = await caches.keys()
      await Promise.all(keys.map(key => caches.delete(key)))
    }
    if ( 'serviceWorker' in navigator ) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map(reg => reg.unregister()))
    }
  } catch (e) {
    console.error(e)
  }
  // cache-bust the HTML so the latest hashed assets are fetched
  const url = new URL(window.location.href)
  url.searchParams.set('_r', Date.now().toString())
  window.location.replace(url.toString())
}

function HiddenReset() {

  const timer = useRef<number | null>(null)

  const start = () => {
    cancel()
    timer.current = window.setTimeout(hardRefresh, HOLD_MS)
  }

  const cancel = () => {
    if ( timer.current ) {
      clearTimeout(timer.current)
      timer.current = null
    }
  }

  return (
    <button
      type="button"
      aria-hidden="true"
      tabIndex={-1}
      onPointerDown={start}
      onPointerUp={cancel}
      onPointerLeave={cancel}
      onPointerCancel={cancel}
      onContextMenu={e => e.preventDefault()}
      style={{
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: 48,
        height: 48,
        opacity: 0,
        border: 0,
        padding: 0,
        background: 'transparent',
        zIndex: 9999,
        touchAction: 'none',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        WebkitTouchCallout: 'none',
        WebkitTapHighlightColor: 'transparent',
      }}
    />
  )
}

export default HiddenReset
